<template>
  <div id="wrap">
    <Header />
    <Contents />
  </div>
</template>

<script>
import Header from '@/layout/web/components/Header'
import Contents from '@/layout/web/components/Contents'

export default {
  name: 'Layout',
  components: {
    Header,
    Contents
  },
  created () {
  }
}
</script>

<style>
  @import '../../assets/web/css/reset.css';
  @import '../../assets/web/css/index.css';
</style>
